/**
 * Dashboard API Module
 * Handles all API calls for dashboard
 */
const DashboardAPI = {
  /**
   * Generic GET request with jQuery
   * @param {string} url - API endpoint URL
   * @param {object} params - Query parameters
   * @returns {Promise} API response
   */
  get(url, params = {}) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        type: "GET",
        data: params,
        success: (response) => resolve(response),
        error: (xhr, status, error) => {
          console.error(`API Error (${url}):`, error);
          reject(error);
        },
      });
    });
  },

  /**
   * Get AWLR last reading
   */
  async getAwlrLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.awlrLastReading,
    );
  },

  async getAgwlrLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.agwlrLastReading,
    );
  },

  async getOwLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.owLastReading,
    );
  },

  /**
   * Get ARR last reading
   */
  async getArrLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.arrLastReading,
    );
  },

  /**
   * Get AWLR+ARR last reading
   */
  async getAwlrArrLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.awlrArrLastReading,
    );
  },

  /**
   * Get AWS last reading
   */
  async getAwsLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.awsLastReading,
    );
  },

  /**
   * Get Vibrating Wire last reading
   */
  async getVibratingWireLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.vibratingWireLastReading,
    );
  },

  /**
   * Get Flow Meter last reading
   */
  async getFlowMeterLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.flowMeterLastReading,
    );
  },

  async getWaterqualityLastReading() {
    return this.get(
      DashboardConfig.api.baseUrl +
        DashboardConfig.api.endpoints.waterQualityLastReading,
    );
  },

  /**
   * Get summary of all stations
   */
  async getSummaryStation() {
    return this.get(
      DashboardConfig.api.baseUrl + DashboardConfig.api.endpoints.summaryPos,
    );
  },

  /**
   * Get all markers for map
   */
  async getMarkers() {
    return this.get(
      DashboardConfig.api.baseUrl + DashboardConfig.api.endpoints.markers,
    );
  },

  /**
   * Get chart data
   * @param {string} type - Chart type (awlr, arr, aws, etc)
   * @param {string} stationId - Station ID
   * @param {string} deviceId - Device ID
   * @param {string} sensor - Sensor type (for AWS)
   */
  async getChartData(type, deviceId, sensor = "") {
    return this.get(
      `${DashboardConfig.api.baseUrl}${DashboardConfig.api.endpoints.grafik}/${type}/${deviceId}/${sensor}`,
    );
  },

  async getChartDataPenampang(stationId) {
    return this.get(
      `${DashboardConfig.api.baseUrl}${DashboardConfig.api.endpoints.penampang}/${stationId}`,
    );
  },

  /**
   * Get CCTV list
   * @param {string} stationId - Station ID (default 'all')
   */
  async getCCTV(stationId = "all") {
    return this.get(
      `${DashboardConfig.api.baseUrl}${DashboardConfig.api.endpoints.cctvs}/${stationId}`,
    );
  },

  /**
   * Get marquee text data
   */
  async getMarqueeData() {
    return this.get(
      DashboardConfig.api.baseUrl + DashboardConfig.api.endpoints.marquee,
    );
  },

  /**
   * Get river files
   */
  async getRiverFiles() {
    return this.get(DashboardConfig.api.endpoints.riverFiles);
  },

  /**
   * Get river areas
   */
  async getRiverAreas() {
    return this.get(DashboardConfig.api.endpoints.riverAreas);
  },

  /**
   * Get well configuration
   * @param {string} deviceId - Device ID
   */
  async getWellConfig(deviceId) {
    return this.get(
      DashboardConfig.api.baseUrl + DashboardConfig.api.endpoints.wellConfig,
      { deviceId },
    );
  },

  /**
   * Get well water level data
   * @param {string} deviceId - Device ID
   */
  async getWellData(deviceId) {
    return this.get(
      DashboardConfig.api.baseUrl + DashboardConfig.api.endpoints.wellData,
      { deviceId },
    );
  },

  /**
   * Get observation well configuration
   * @param {string} deviceId - Device ID
   */
  async getOwWellConfig(deviceId) {
    return this.get(
      DashboardConfig.api.baseUrl + DashboardConfig.api.endpoints.owWellConfig,
      { deviceId },
    );
  },

  /**
   * Get observation well water level data
   * @param {string} deviceId - Device ID
   */
  async getOwWellData(deviceId) {
    return this.get(
      DashboardConfig.api.baseUrl + DashboardConfig.api.endpoints.owWellData,
      { deviceId },
    );
  },

  /**
   * Get station types total
   */
  async getStationTypes() {
    return this.get(DashboardConfig.api.endpoints.stationTypes);
  },
};
